import { useState } from 'preact/hooks';
import { route } from 'preact-router';

export function TrialBanner({ subscription }) {
  const [dismissed, setDismissed] = useState(false);

  if (!subscription || subscription.status !== 'trialing') {
    return null;
  }

  if (dismissed) {
    return null;
  }

  const daysRemaining = subscription.days_remaining || 0;
  const isUrgent = daysRemaining <= 3;

  function handleUpgrade() {
    route('/upgrade');
  }

  return (
    <div class={`trial-banner ${isUrgent ? 'trial-banner-urgent' : ''}`}>
      <div class="trial-banner-content">
        <span class="trial-banner-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
          </svg>
        </span>
        <span class="trial-banner-text">
          {daysRemaining === 0 && 'Your trial ends today!'}
          {daysRemaining === 1 && 'Your trial ends tomorrow!'}
          {daysRemaining > 1 && `Trial ends in ${daysRemaining} days.`}
        </span>
        <button
          class="trial-banner-button"
          onClick={handleUpgrade}
        >
          Upgrade Now
        </button>
        <button
          class="trial-banner-dismiss"
          onClick={() => setDismissed(true)}
          aria-label="Dismiss"
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>

      <style>{`
        .trial-banner {
          background: linear-gradient(90deg, #3b82f6 0%, #2563eb 100%);
          color: white;
          padding: 0.75rem 1rem;
        }

        .trial-banner-urgent {
          background: linear-gradient(90deg, #f59e0b 0%, #d97706 100%);
        }

        .trial-banner-content {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.75rem;
          max-width: 1200px;
          margin: 0 auto;
        }

        .trial-banner-icon {
          display: flex;
          width: 20px;
          height: 20px;
          flex-shrink: 0;
        }

        .trial-banner-icon svg {
          width: 100%;
          height: 100%;
        }

        .trial-banner-text {
          font-size: 0.875rem;
          font-weight: 500;
        }

        .trial-banner-button {
          background: rgba(255, 255, 255, 0.2);
          color: white;
          border: 1px solid rgba(255, 255, 255, 0.3);
          padding: 0.375rem 0.75rem;
          border-radius: 6px;
          font-size: 0.8125rem;
          font-weight: 500;
          cursor: pointer;
          transition: background 0.2s;
        }

        .trial-banner-button:hover {
          background: rgba(255, 255, 255, 0.3);
        }

        .trial-banner-button:disabled {
          opacity: 0.7;
          cursor: not-allowed;
        }

        .trial-banner-dismiss {
          background: none;
          border: none;
          color: white;
          opacity: 0.7;
          cursor: pointer;
          padding: 0.25rem;
          display: flex;
          transition: opacity 0.2s;
        }

        .trial-banner-dismiss:hover {
          opacity: 1;
        }

        .trial-banner-dismiss svg {
          width: 16px;
          height: 16px;
        }

        @media (max-width: 640px) {
          .trial-banner-content {
            flex-wrap: wrap;
          }

          .trial-banner-text {
            order: 1;
            flex: 1 1 100%;
            text-align: center;
            margin-bottom: 0.5rem;
          }

          .trial-banner-icon {
            display: none;
          }
        }
      `}</style>
    </div>
  );
}
